import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'notificationtime'
})
export class NotificationTimePipe implements PipeTransform {
  transform(value: any) : string {

    if (!value) {
      return null;
    }

    let res = '';

    if (value > 0) {
      if (value === 1) {
        res = '1 hora';
      } else if (value >= 24) {
        let days = Math.floor(value/24);
        res =  days + (days > 1 ? ' días' : ' día');
        let hours = value % 24;
        if (hours > 0) {
          res +=  ' y ' + hours + (hours > 1 ? ' horas' : ' hora');
        }
      } else {
        res =  value + ' horas';
      }
    }

    return res;
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/pipes/notificationtime.ts